import { render } from "./VerificationDetail.vue?vue&type=template&id=b87dd7ec&scoped=true"
import script from "./VerificationDetail.vue?vue&type=script&lang=js"
export * from "./VerificationDetail.vue?vue&type=script&lang=js"

import "./VerificationDetail.vue?vue&type=style&index=0&id=b87dd7ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b87dd7ec"]])

export default __exports__